const PNP_REFRESH_V1 = 'GROW-2792';
const DESC_MESSAGE = '[Type: String][Vis.: high] - features summary - A string in pricing experiment GROW-2792';

const experimentSummaryCopy = {
  grow_2792_base_response_count: {
    id: 'Pricing.cellCopy.BaseResponseCount',
    defaultMessage: '{amount} responses per year**',
    desc: {
      id: 'Pricing.experimentSummaryCopy.BaseResponseCount',
      message: `${DESC_MESSAGE} - BaseResponseCount`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_skip_logic: {
    id: 'Pricing.experimentSummaryCopy.JustSkipLogic',
    defaultMessage: 'Skip logic',
    desc: {
      id: 'Pricing.experimentSummaryCopy.JustSkipLogic',
      message: `${DESC_MESSAGE} - SkipLogic`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_create_custom_theme_enabled: {
    id: 'Pricing.experimentSummaryCopy.CreateCustomThemesEnabled',
    defaultMessage: 'Custom themes, colors, and more',
    desc: {
      id: 'Pricing.experimentSummaryCopy.CreateCustomThemesEnabled',
      message: `${DESC_MESSAGE} - CreateCustomThemesEnabled`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_custom_colors: {
    id: 'Pricing.experimentSummaryCopy.CustomColors',
    defaultMessage: 'Custom colors',
    desc: {
      id: 'Pricing.experimentSummaryCopy.CustomColors',
      message: `${DESC_MESSAGE} - CustomColors`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_custom_colors_survey_url: {
    id: 'Pricing.experimentSummaryCopy.CustomColorsSurveyUrl',
    defaultMessage: 'Custom colors & survey URL',
    desc: {
      id: 'Pricing.experimentSummaryCopy.CustomColorsSurveyUrl',
      message: `${DESC_MESSAGE} - CustomColorsSurveyUrl`,
      project: PNP_REFRESH_V1,
    },
  },
  // needed for tooltip override
  grow_2792_priority_email_support: {
    id: 'Pricing.copy.SummaryPrimaryEmailSupport',
    defaultMessage: '24/7 expedited email support',
    desc: {
      id: 'Pricing.copy.SummaryPrimaryEmailSupport',
      message: `${DESC_MESSAGE} - SummaryPrimaryEmailSupport`,
      project: PNP_REFRESH_V1,
    },
  },
  // needed for tooltip override
  grow_2792_phone_support: {
    id: 'Pricing.copy.SummaryPhoneSupport',
    defaultMessage: 'Phone support and 24/7 email support',
    desc: {
      id: 'Pricing.copy.SummaryPhoneSupport',
      message: `${DESC_MESSAGE} - SummaryPhoneSupport`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_single_user: {
    id: 'Pricing.experimentSummaryCopy.SingleUser',
    defaultMessage: 'Single user',
    desc: {
      id: 'Pricing.experimentSummaryCopy.SingleUser',
      message: `${DESC_MESSAGE} - SingleUser`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_basic_base_response_count: {
    id: 'Pricing.experimentSummaryCopy.ResponseCount',
    defaultMessage: '{amount} responses per survey',
    desc: {
      id: 'Pricing.experimentSummaryCopy.ResponseCount',
      message: `${DESC_MESSAGE} - ResponseCount`,
      project: PNP_REFRESH_V1,
    },
  },
  // needed for tooltip override
  grow_2792_basic_create_question_limit: {
    id: 'Pricing.experimentSummaryCopy.QuestionsPerFormSurveyBasic',
    defaultMessage: '{amount} questions per survey',
    desc: {
      id: 'Pricing.experimentSummaryCopy.QuestionsPerFormSurveyBasic',
      message: `${DESC_MESSAGE} - QuestionsPerFormSurveyBasic`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_create_question_limit: {
    id: 'Pricing.experimentSummaryCopy.QuestionsPerFormSurvey',
    defaultMessage: '{amount} questions per survey',
    desc: {
      id: 'Pricing.experimentSummaryCopy.QuestionsPerFormSurvey',
      message: `${DESC_MESSAGE} - QuestionsPerFormSurvey`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_collector_create_limit: {
    id: 'Pricing.experimentSummaryCopy.CollectorsPerSurvey',
    defaultMessage: '{amount} collectors per survey',
    desc: {
      id: 'Pricing.experimentSummaryCopy.CollectorsPerSurvey',
      message: `${DESC_MESSAGE} - CollectorsPerSurvey`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_support: {
    id: 'Pricing.experimentSummaryCopy.Support',
    defaultMessage: '24/7 email support',
    desc: {
      id: 'Pricing.experimentSummaryCopy.Support',
      message: `${DESC_MESSAGE} - Support`,
    },
  },
  grow_2792_forms_advantage_team: {
    id: 'Pricing.experimentSummaryCopy.FormsAdvantageUser',
    defaultMessage: 'Single user',
    desc: {
      id: 'Pricing.experimentSummaryCopy.FormsAdvantageUser',
      message: `${DESC_MESSAGE} - SingleUser`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_team_collaboration_user: {
    id: 'Pricing.experimentSummaryCopy.TeamCollaborationUser',
    defaultMessage: 'Team collaboration with 3+ users',
    desc: {
      id: 'Pricing.experimentSummaryCopy.TeamCollaborationUser',
      message: `${DESC_MESSAGE} - TeamCollaborationUser`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_advanced_team_collaboration_user: {
    id: 'Pricing.experimentSummaryCopy.AdvancedTeamCollaborationUser',
    defaultMessage: 'Advanced team collaboration',
    desc: {
      id: 'Pricing.experimentSummaryCopy.AdvancedTeamCollaborationUser',
      message: `${DESC_MESSAGE} - AdvancedTeamCollaborationUser`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_survey_create_limit: {
    id: 'Pricing.experimentSummaryCopy.SurveyFormsCreateLimit',
    defaultMessage: 'Unlimited surveys and forms',
    desc: {
      id: 'Pricing.experimentSummaryCopy.SurveyFormsCreateLimit',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_unlimited_questions: {
    id: 'Pricing.experimentSummaryCopy.UnlimitedFieldsPerForm',
    defaultMessage: 'Unlimited questions per survey',
    desc: {
      id: 'Pricing.experimentSummaryCopy.UnlimitedFieldsPerForm',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_essential_question_types: {
    id: 'Pricing.copy.SummaryEssentialQuestionTypesOnly',
    defaultMessage: 'Essential question types only',
    desc: {
      id: 'Pricing.experimentSummaryCopy.SummaryEssentialQuestionTypes',
      message: `${DESC_MESSAGE} - SummaryEssentialQuestionTypesOnly`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_forms_question_types: {
    id: 'Pricing.experimentSummaryCopy.FormsQuestionTypes',
    defaultMessage: 'Form question types',
    desc: {
      id: 'Pricing.experimentSummaryCopy.FormsQuestionTypesDesc',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_all_question_types_t1_t2: {
    id: 'Pricing.experimentSummaryCopy.AllQuestionTypes',
    defaultMessage: 'All question types',
    desc: {
      id: 'Pricing.experimentSummaryCopy.AllQuestionTypesDesc',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_all_question_types_t3: {
    id: 'Pricing.experimentSummaryCopy.AllQuestionTypes',
    defaultMessage: 'All question types',
    desc: {
      id: 'Pricing.experimentSummaryCopy.AllQuestionTypesDesc',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_basic_question_types: {
    id: 'Pricing.experimentSummaryCopy.BasicQuestionTypes',
    defaultMessage: 'Essential question types only',
    desc: {
      id: 'Pricing.experimentSummaryCopy.BasicQuestionTypes',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_analyze_export_enabled: {
    id: 'Pricing.experimentSummaryCopy.AnalyzeExportEnabled',
    defaultMessage: 'Data exports (CSV, PDF, PPT, XLS)',
    desc: {
      id: 'Pricing.experimentSummaryCopy.AnalyzeExportEnabledDesc',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_website_embed: {
    id: 'Pricing.experimentSummaryCopy.WebsiteEmbed',
    defaultMessage: 'Website embed',
    desc: {
      id: 'Pricing.experimentSummaryCopy.WebsiteEmbed',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_zapier_integrations: {
    id: 'Pricing.experimentSummaryCopy.ZapierIntegrations',
    defaultMessage: '5000+ integrations with Zapier',
    desc: {
      id: 'Pricing.experimentSummaryCopy.ZapierIntegrations',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_text_analysis: {
    id: 'Pricing.experimentSummaryCopy.TextAnalysis',
    defaultMessage: 'Text Analysis',
    desc: {
      id: 'Pricing.experimentSummaryCopy.TextAnalysis',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_a_b_testing: {
    id: 'Pricing.experimentSummaryCopy.ABTesting',
    defaultMessage: 'A/B testing & Statistical Significance',
    desc: {
      id: 'Pricing.experimentSummaryCopy.ABTesting',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_custom_response_limits: {
    id: 'Pricing.experimentSummaryCopy.CustomResponseLimits',
    defaultMessage: 'Custom response limits',
    desc: {
      id: 'Pricing.experimentSummaryCopy.CustomResponseLimits',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },

  // IPPM specific features
  grow_2792_ippm_a_b_testing: {
    id: 'Pricing.experimentIPPMSummaryCopy.ABTesting',
    defaultMessage: 'A/B test text and images',
    desc: {
      id: 'Pricing.experimentIPPMSummaryCopy.ABTesting',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_ippm_create_piping_enabled: {
    id: 'Pricing.experimentIPPMSummaryCopy.CreatePipingEnabled',
    defaultMessage: 'Question & answer piping',
    desc: {
      id: 'Pricing.experimentIPPMSummaryCopy.CreatePipingEnabled',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_ippm_best_worst_scale: {
    id: 'Pricing.experimentIPPMSummaryCopy.BestWorstScale',
    defaultMessage: 'Best worst scale',
    desc: {
      id: 'Pricing.experimentIPPMSummaryCopy.BestWorstScale',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_ippm_response_count: {
    id: 'Pricing.cellCopy.IPPMResponseCount',
    defaultMessage: '{amount} responses per {frequency}**',
    desc: {
      id: 'Pricing.experimentSummaryCopy.IPPMResponseCount',
      message: `${DESC_MESSAGE} - IPPMResponseCount`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_ippm_advanced_data_exports: {
    id: 'Pricing.cellCopy.IPPMAdvancedDataExports',
    defaultMessage: 'Advanced data exports',
    desc: {
      id: 'Pricing.experimentSummaryCopy.IPPMAdvancedDataExports',
      message: `${DESC_MESSAGE} - IPPMAdvancedDataExports`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_advanced_branching: {
    id: 'Pricing.experimentIPPMSummaryCopy.AdvancedBranching',
    defaultMessage: 'Advanced Branching Logic',
    desc: {
      id: 'Pricing.experimentIPPMSummaryCopy.AdvancedBranching',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_star_rating_question_type: {
    id: 'Pricing.experimentIPPMPaidFeatureCopy.StarRating',
    defaultMessage: 'Rating question',
    desc: {
      id: 'Pricing.experimentIPPMPaidFeatureCopy.StarRating',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_textbox_multiple_question_type: {
    id: 'Pricing.experimentIPPMPaidFeatureCopy.MultipleTextboxes',
    defaultMessage: 'Multiple Textboxes',
    desc: {
      id: 'Pricing.experimentIPPMPaidFeatureCopy.MultipleTextboxes',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_comment_box_question_type: {
    id: 'Pricing.experimentIPPMPaidFeatureCopy.CommentBox',
    defaultMessage: 'Comment box question',
    desc: {
      id: 'Pricing.experimentIPPMPaidFeatureCopy.CommentBox',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_create_custom_chatbot_avatar: {
    id: 'Pricing.experimentIPPMPaidFeatureCopy.CustomAvatar',
    defaultMessage: 'Add your custom avatar',
    desc: {
      id: 'Pricing.experimentIPPMPaidFeatureCopy.CustomAvatar',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_funneling_enabled: {
    id: 'Pricing.experimentIPPMPaidFeatureCopy.Funneling',
    defaultMessage: 'Carry Forward Responses',
    desc: {
      id: 'Pricing.experimentIPPMPaidFeatureCopy.Funneling',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_create_random_assignment_enabled: {
    id: 'Pricing.experimentIPPMPaidFeatureCopy.RandomAssignment',
    defaultMessage: 'A/B test text and images',
    desc: {
      id: 'Pricing.experimentIPPMPaidFeatureCopy.RandomAssignment',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_ippm_create_question_limit: {
    id: 'Pricing.experimentSummaryCopy.IPPMQuestionsPerFormSurvey',
    defaultMessage: 'Unlimited questions',
    desc: {
      id: 'Pricing.experimentSummaryCopy.IPPMQuestionsPerFormSurvey',
      message: `${DESC_MESSAGE} - IPPM QuestionsPerFormSurvey`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_ippm_file_upload: {
    id: 'Pricing.experimentSummaryCopy.IPPMFileUplaod',
    defaultMessage: 'Let survey takers upload files',
    desc: {
      id: 'Pricing.experimentSummaryCopy.IPPMFileUplaod',
      message: `${DESC_MESSAGE} - IPPMFileUplaod`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_ippm_matrix_question_type: {
    id: 'Pricing.experimentSummaryCopy.IPPMMatrixQuestionType',
    defaultMessage: 'Matrix/Rating Scale questions',
    desc: {
      id: 'Pricing.experimentSummaryCopy.IPPMMatrixQuestionType',
      message: `${DESC_MESSAGE} - IPPMMatrixQuestionType`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_ippm_create_randomization_enabled_question: {
    id: 'Pricing.experimentSummaryCopy.IPPMCreateRandomizationEnabledQuestions',
    defaultMessage: 'Randomize questions',
    desc: {
      id: 'Pricing.experimentSummaryCopy.IPPMCreateRandomizationEnabledQuestions',
      message: `${DESC_MESSAGE} - IPPMCreateRandomizationEnabledQuestions`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_ippm_create_randomization_enabled_page: {
    id: 'Pricing.experimentSummaryCopy.IPPMCreateRandomizationEnabledPage',
    defaultMessage: 'Randomize pages',
    desc: {
      id: 'Pricing.experimentSummaryCopy.IPPMCreateRandomizationEnabledPage',
      message: `${DESC_MESSAGE} - IPPMCreateRandomizationEnabledPage`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_ippm_create_custom_theme_enabled: {
    id: 'Pricing.experimentSummaryCopy.IPPMCreateCustomTheme',
    defaultMessage: 'Custom themes',
    desc: {
      id: 'Pricing.experimentSummaryCopy.IPPMCreateCustomTheme',
      message: `${DESC_MESSAGE} - IPPMCreateCustomTheme`,
      project: PNP_REFRESH_V1,
    },
  },
};

export default experimentSummaryCopy;
